export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-alert-b6f33b4c5ef58247814a4bb96e435147.svg";